import React from 'react';
import './hac-profile.scss';
import { Navigate } from 'react-router-dom';
import decodeToken from '../../../../utils/decode-token';
import EditHacProfile from '../../../organisms/common/hac-profile/org-hac-profile.js';
import { canAccessHacManagement } from '../../../../utils/role-utils';

const HacProfile = () => {
  const token = sessionStorage.getItem('token') || null;
  const role = decodeToken(token).role;

  return (
    <>
      {token && canAccessHacManagement(role) ? (
        <main>

          <EditHacProfile />
        </main>
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
};

export default HacProfile;
